import { APIModel, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { TransactionHistoryDtoImpl } from '../../../../core/dto/transactionhistory/transactionhistorydto';
import { TransactionHistoryResponse } from '../../../../core/api/myaccount/transactionhistory/transactionhistoryresponse';
import { TransactionHistoryRequestImpl } from '../../../../core/api/myaccount/transactionhistory/transactionhistoryrequest';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export interface TransactionHistoryAPIModel extends APIModel
{
    getTransactionHistory(): void;
}

export class TransactionHistoryAPIModelImpl extends APIModelImpl implements TransactionHistoryAPIModel
{
    getTransactionHistory(): void 
    {
        let transactionHistoryDto = new TransactionHistoryDtoImpl();
        transactionHistoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        transactionHistoryDto.setFromDate(this.getPreviousDate(30));
        transactionHistoryDto.setToDate(this.getCurrentDate());


        console.log("Current Date() =-------",transactionHistoryDto.getToDate());
        console.log("Previous Date() ------",this.getPreviousDate(30));
        this.getAPIProcesssorFactory().getMyAccountProcessorFactory()
        .getTransactionHistoryDetails()
        .success((transactionHistoryResponse: TransactionHistoryResponse)=>
        {
            console.log("Feature -------",transactionHistoryResponse.getAPIFeature());

            this.getAPIModelHandler().onSuccess(transactionHistoryResponse.getAPIFeature(), 
            transactionHistoryResponse.getDescription(), 
            transactionHistoryResponse.getTransactionHistoryDtos());
          
         })
        .failure((transactionHistoryResponse: TransactionHistoryResponse)=>
         {
           this.getAPIModelHandler().onFailure(transactionHistoryResponse.getAPIFeature(), 
           transactionHistoryResponse.getDescription(), undefined);
         })
        .execute(new TransactionHistoryRequestImpl(transactionHistoryDto));
    }


    getCurrentDate():string
    {
        let currentDate = new Date();
        let dd = currentDate.getDate().toString();
        let mm = (currentDate.getMonth()+1).toString();
        let yyyy = currentDate.getFullYear().toString();
       
        if(currentDate.getDate()<10) 
        {
            dd ='0'+dd;
        } 

        if(currentDate.getMonth()<10) 
        {
          mm='0'+mm;
        } 
        let today =dd+'-'+mm+'-'+yyyy;
        console.log("the current date: ---",today);
        return today;        
    }

    getPreviousDate(days:number):string
    {
        let date = new Date();
        let last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
        let day = last.getDate().toString();
        let month = (last.getMonth()+1).toString();
        let year = last.getFullYear();
        if(last.getDate()<10)
        {
            day = this.getContext().getResources().getString(Strings.zero)+day;
        }
        if(last.getMonth()<10)
        {
            month = this.getContext().getResources().getString(Strings.zero)+month;
        }
       
        let pastDate = day+"-"+month+"-"+year;

        console.log("past date :",pastDate);
        return pastDate;
    }
   
    // private getHistoryData()
    // {
    //     let transaction1 = new TransactionHistoryDtoImpl();
    //     transaction1.setId("1");
    //     transaction1.setTitle("oiuytredfghjk");
    //     transaction1.setTimeStamp("1:23:13");
    //     transaction1.setChannel("SMS");
    //     transaction1.setPrice("1");
    //     transaction1.setTransactionType("egrg");

    //     let transaction2 = new TransactionHistoryDtoImpl();
    //     transaction2.setId("1");
    //     transaction2.setTitle("sdfghjk");
    //     transaction2.setTimeStamp("1:23:13");
    //     transaction2.setChannel("SMS");
    //     transaction2.setPrice("1");
    //     transaction2.setTransactionType("egrg");


    //     let transaction3 = new TransactionHistoryDtoImpl();
    //     transaction3.setId("1");
    //     transaction3.setTitle("oiuytrewsdcvbnm,k");
    //     transaction3.setTimeStamp("1:23:13");
    //     transaction3.setChannel("SMS");
    //     transaction3.setPrice("1");
    //     transaction3.setTransactionType("egrg");

    //     let transaction4 = new TransactionHistoryDtoImpl();
    //     transaction4.setId("1");
    //     transaction4.setTitle("oiuytresdxcvbnjm,kliuytfg");
    //     transaction4.setTimeStamp("1:23:13");
    //     transaction4.setChannel("SMS");
    //     transaction4.setPrice("1");
    //     transaction4.setTransactionType("egrg");

    //     return [transaction1, transaction2, transaction3, transaction4];
    // }
    
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/transactionhistoryapimodel.tsx